import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class CreateNewThreadBaseComponent extends BaseComponent {
  public text: string = "CreateNewThread";

  constructor(userService: UserService) {
    super(userService);
  }
}
